import { useState } from "react";
import { Dimmer, Grid, Loader } from "semantic-ui-react";
import { useGetSimulatedFacilityPagesList } from "../../../api/facility";
import { CustomButton } from "../../../components/button/Button";
import { CommonModal } from "../../../components/commonModal/CommonModal";
import CommonSplitContainer from "../../../components/commonSplitContainer/CommonSplitContainer";
import MainBottomMultipleButtonView from "../../../components/mainBottomButtonView/MainBottomMultipleButtonView";
import FacilitySimulationRegisterModal from "./FacilitySimulationRegisterModal";
import FacilitySimulationTable from "./FacilitySimulationTable";

interface FacilitySimulationModalProps {
  visibleModal: boolean;
  onClose: (visible: boolean) => void;
  facilityData: any;
}

const FacilitySimulationModal = ({
  visibleModal,
  onClose,
  facilityData
}: FacilitySimulationModalProps) => {
  const [visibleSimulationRegisterModal, setVisibleSimulationRegisterModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const {
    data: simulatedFacilities,
    isFetching: isLoadingSimulatedFacilities,
    refetch
  } = useGetSimulatedFacilityPagesList(facilityData?._id, pageNumber, pageSize);

  if (isLoadingSimulatedFacilities) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <CommonModal
      modalOpenState={visibleModal}
      modalCloseState={onClose}
      centered={true}
      title={facilityData?.facilityName}
    >
      <Grid>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <CommonSplitContainer
            currentHeight={0.91}
            topChild={
              <>
                <Grid>
                  <Grid.Row>
                    <Grid.Column textAlign="right">
                      <CustomButton
                        theme="green"
                        title="Add New Simulation"
                        buttonOutLine={false}
                        onClick={() => setVisibleSimulationRegisterModal(true)}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <FacilitySimulationTable
                  data={simulatedFacilities}
                  setPageNumber={setPageNumber}
                  setPageSize={setPageSize}
                  pageNumber={pageNumber}
                  pageSize={pageSize}
                  refetch={refetch}
                />
                <FacilitySimulationRegisterModal
                  visibleModal={visibleSimulationRegisterModal}
                  setVisibleModal={() => {
                    setVisibleSimulationRegisterModal(false);
                    refetch();
                  }}
                  currentFacilityData={facilityData}
                />
              </>
            }
            bottomChild={
              <MainBottomMultipleButtonView
                leftButtons={[
                  {
                    title: "Cancel",
                    onClick: () => onClose(true),
                    buttonOutLine: true
                  }
                ]}
              />
            }
          />
        </Grid.Column>
      </Grid>
    </CommonModal>
  );
};

export default FacilitySimulationModal;
